export const SwitchHeroLarge = ({
  illustrationColorLight = 'var(--brand-color-purple-3)',
  illustrationColorDark = 'var(--brand-color-purple-7)',
}) => {
  return (
    <svg
      width="756"
      height="1122"
      viewBox="0 0 756 1122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M161 641L160.47 641.53L160.689 641.75H161V641ZM1 481H0.25V481.311L0.469666 481.53L1 481ZM1 73L0.469666 72.4697L0.25 72.6893V73H1ZM73 1V0.25H72.6893L72.4697 0.469666L73 1ZM89 1L89.5303 0.469666L89.3107 0.25H89V1ZM161 73H161.75V72.6893L161.53 72.4697L161 73ZM161 400H160.25V400.308L160.466 400.527L161 400ZM241 481L240.466 481.527L240.687 481.75H241V481ZM287 481L287.53 480.47L287.311 480.25H287V481ZM359 553H359.75V552.689L359.53 552.47L359 553ZM359 569L359.53 569.53L359.75 569.311V569H359ZM287 641V641.75H287.311L287.53 641.53L287 641ZM161 641L161.53 640.47L1.53033 480.47L1 481L0.469666 481.53L160.47 641.53L161 641ZM1 481H1.75V73H1H0.25V481H1ZM1 73L1.53033 73.5303L73.5303 1.53033L73 1L72.4697 0.469666L0.469666 72.4697L1 73ZM73 1V1.75H89V1V0.25H73V1ZM89 1L88.4697 1.53033L160.47 73.5303L161 73L161.53 72.4697L89.5303 0.469666L89 1ZM161 73H160.25V400H161H161.75V73H161ZM161 400L160.466 400.527L240.466 481.527L241 481L241.534 480.473L161.534 399.473L161 400ZM241 481V481.75H287V481V480.25H241V481ZM287 481L286.47 481.53L358.47 553.53L359 553L359.53 552.47L287.53 480.47L287 481ZM359 553H358.25V569H359H359.75V553H359ZM359 569L358.47 568.47L286.47 640.47L287 641L287.53 641.53L359.53 569.53L359 569ZM287 641V640.25H161V641V641.75H287V641Z"
        fill={illustrationColorLight}
      />
      <g opacity="0.25">
        <path
          d="M400 481L560 641V1049L488 1121H472L400 1049V722L320 641H272L200 569V553L272 481H400Z"
          fill={illustrationColorDark}
        />
        <path
          d="M400 481L400.53 480.47L400.311 480.25H400V481ZM560 641H560.75V640.689L560.53 640.47L560 641ZM560 1049L560.53 1049.53L560.75 1049.31V1049H560ZM488 1121V1121.75H488.311L488.53 1121.53L488 1121ZM472 1121L471.47 1121.53L471.689 1121.75H472V1121ZM400 1049H399.25V1049.31L399.47 1049.53L400 1049ZM400 722H400.75V721.692L400.534 721.473L400 722ZM320 641L320.534 640.473L320.313 640.25H320V641ZM272 641L271.47 641.53L271.689 641.75H272V641ZM200 569H199.25V569.311L199.47 569.53L200 569ZM200 553L199.47 552.47L199.25 552.689V553H200ZM272 481V480.25H271.689L271.47 480.47L272 481ZM400 481L399.47 481.53L559.47 641.53L560 641L560.53 640.47L400.53 480.47L400 481ZM560 641H559.25V1049H560H560.75V641H560ZM560 1049L559.47 1048.47L487.47 1120.47L488 1121L488.53 1121.53L560.53 1049.53L560 1049ZM488 1121V1120.25H472V1121V1121.75H488V1121ZM472 1121L472.53 1120.47L400.53 1048.47L400 1049L399.47 1049.53L471.47 1121.53L472 1121ZM400 1049H400.75V722H400H399.25V1049H400ZM400 722L400.534 721.473L320.534 640.473L320 641L319.466 641.527L399.466 722.527L400 722ZM320 641V640.25H272V641V641.75H320V641ZM272 641L272.53 640.47L200.53 568.47L200 569L199.47 569.53L271.47 641.53L272 641ZM200 569H200.75V553H200H199.25V569H200ZM200 553L200.53 553.53L272.53 481.53L272 481L271.47 480.47L199.47 552.47L200 553ZM272 481V481.75H400V481V480.25H272V481Z"
          fill={illustrationColorDark}
        />
      </g>
      <path
        d="M683 481L755 553V569L683 641H272L200 569V553L272 481H683Z"
        stroke={illustrationColorLight}
        strokeWidth="1.5"
        strokeDasharray="3"
      />
      <circle
        opacity="0.75"
        cx="78"
        cy="356"
        r="50"
        fill={illustrationColorLight}
      />
    </svg>
  );
};

export const SwitchHeroSmall = ({
  illustrationColorLight = 'var(--brand-color-purple-3)',
  illustrationColorDark = 'var(--brand-color-purple-7)',
}) => {
  return (
    <svg
      width="1573"
      height="122"
      viewBox="0 0 1573 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1518 1L1572 55V67L1518 121H666L612 67V55L666 1H1518Z"
        stroke={illustrationColorLight}
        strokeWidth="1.5"
        strokeDasharray="3"
      />
      <path
        d="M1142 1L1196 55V67L1142 121H290L236 67V55L290 1H1142Z"
        stroke={illustrationColorLight}
        strokeWidth="1.5"
      />
      <path
        d="M907 1L961 55V67L907 121H55L1 67V55L55 1H907Z"
        fill={illustrationColorDark}
        stroke={illustrationColorDark}
        strokeWidth="1.5"
        opacity="0.25"
      />
      <path
        opacity="0.75"
        d="M1091 61C1091 83.0914 1073.09 101 1051 101C1028.91 101 1011 83.0914 1011 61C1011 38.9086 1028.91 21 1051 21C1073.09 21 1091 38.9086 1091 61Z"
        fill={illustrationColorLight}
      />
    </svg>
  );
};
